__turbopack_context__.v({
  "button": "text-image-block-module-scss-module__EWKkgq__button",
  "button1": "text-image-block-module-scss-module__EWKkgq__button1",
  "buttonSimple": "text-image-block-module-scss-module__EWKkgq__buttonSimple",
  "buttonSimple1": "text-image-block-module-scss-module__EWKkgq__buttonSimple1",
  "buttongroup": "text-image-block-module-scss-module__EWKkgq__buttongroup",
  "container": "text-image-block-module-scss-module__EWKkgq__container",
  "iconWrapper": "text-image-block-module-scss-module__EWKkgq__iconWrapper",
  "imageIcon": "text-image-block-module-scss-module__EWKkgq__imageIcon",
  "imageIcon1": "text-image-block-module-scss-module__EWKkgq__imageIcon1",
  "li": "text-image-block-module-scss-module__EWKkgq__li",
  "list": "text-image-block-module-scss-module__EWKkgq__list",
  "subtitle": "text-image-block-module-scss-module__EWKkgq__subtitle",
  "text": "text-image-block-module-scss-module__EWKkgq__text",
  "text1": "text-image-block-module-scss-module__EWKkgq__text1",
  "textimageblock": "text-image-block-module-scss-module__EWKkgq__textimageblock",
  "title": "text-image-block-module-scss-module__EWKkgq__title",
});
